import axios, { AxiosResponse } from "axios";


import {
  ICreateCustDiagnosticsRequest,
  ICreateCustDiagnosticsResponse,
  IGetDeviceTypesResponse,
  IGetDiagnosticStepResp,
  IGetOSTypesResponse,
  IGetPrimaryIssueTypeResponse,
  IGetProblemTypesResponse,
  IGetResolutionRequest,
  IGetResolutionResponse,
} from "../model/dto";


 axios.defaults.baseURL = "https://app.trustedtechy.co.uk/api";
//  axios.defaults.baseURL = "http://localhost/tt-api-01/api";

// axios.defaults.headers = {
//   // ApiKey: process.env.REACT_APP_ADMIN_API_KEY,
// };

const responseBody = (response: AxiosResponse) => response.data;

const requests = {
  get: (url: string) => axios.get(url).then(responseBody),
  post: (url: string, body: object) => axios.post(url, body).then(responseBody),
  put: (url: string, body: object) => axios.put(url, body).then(responseBody),
  delete: (url: string) => axios.delete(url).then(responseBody),
};

const DiagnosticStep = {
  getDiagnosticStep: (
    diagStepId: number
  ): Promise<IGetDiagnosticStepResp | any> =>
    requests.get("/diagnosis/getStep.php?id=" + diagStepId),
};

const Resolution = {
  getResolutionDetails: (
    resLinkId: IGetResolutionRequest
  ): Promise<IGetResolutionResponse | any> =>
    requests.post("/resolution/getResolution.php", resLinkId),
};

const CustDiagnosis = {
  createCustomerDiagnosis: (
    custDiag: ICreateCustDiagnosticsRequest
  ): Promise<ICreateCustDiagnosticsResponse | any> =>
    requests.post("/customerdiagnosis/create", custDiag),
};

const InitialProblem = {
  getPrimaryIssueType: (
    deviceId: number,
    problemId: number,
    osId: number
  ): Promise<IGetPrimaryIssueTypeResponse | any> =>
    requests.get(
      "/primaryissue/getPrimaryIssue.php?id1=" +
        deviceId +
        "&id2=" +
        problemId +
        "&id3= " +
        osId
    ),

  getPrimaryIssueStartStep: (
    deviceId: number,
    problemId: number,
    osId: number
  ): Promise<IGetDiagnosticStepResp | any> =>
    requests.get(
      "/primaryissue/getPrimaryIssueStep.php?id1=" +
        deviceId +
        "&id2=" +
        problemId +
        "&id3= " +
        osId
    ),

  getDevicetypes: (): Promise<IGetDeviceTypesResponse | any> =>
    requests.get("/primaryissue/getDevices.php"),
  getOStypes: (
    deviceId: number,
    problemId: number
  ): Promise<IGetOSTypesResponse | any> =>
    requests.get(
      "/primaryissue/getOperatingSystems.php?id1=" +
        deviceId +
        "&id2=" +
        problemId
    ),
  getProblemtypes: (
    deviceId: number
  ): Promise<IGetProblemTypesResponse | any> =>
    requests.get("/primaryissue/getProblems.php?id=" + deviceId),
};

export default { InitialProblem, DiagnosticStep, CustDiagnosis, Resolution };
